import { STRATEGY, ERROR } from "./actions.type";
import { Strategies } from '@/firebase'

const state = {
  items: null
};
const mutations = {
  [STRATEGY.SET](state, items) {
    state.items = items;
  }
};

const getters = {
  strategies(state) {
    return state.items;
  }
};

const actions = {
  async [STRATEGY.FETCH](context, userId) {
    const snapshot = await Strategies.where('userId', '==', userId).get()
      .catch(e => {
        context.commit(ERROR.SET, e);
      });
    if (snapshot.empty) {
      context.commit(ERROR.SET, 'No strategy');
      return;
    }
    const data = []
    snapshot.forEach(doc => {
      data.push(doc.data())
    });
    context.commit(STRATEGY.SET, data);
  },
  async [STRATEGY.CREATE](context, schema) {
    const res = await Strategies.add(schema)
      .catch(e => {
        context.commit(ERROR.SET, e);
      });

    return res
  },
  async [STRATEGY.EDIT](context, schema) {
    const res = await Strategies.doc(schema.id).update(schema)
      .catch(e => {
        context.commit(ERROR.SET, e);
      });

    return res
  },
  async [STRATEGY.DEL](context, schema) {
    const res = await Strategies.doc(schema.id).delete()
      .catch(e => {
        context.commit(ERROR.SET, e);
      });

    return res
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
